import { QueryClient } from 'react-query';

const reactQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // for dev - allows for errors to resolve instead of retrying
            retry: process.env.NODE_ENV === 'production',
            refetchOnWindowFocus: process.env.NODE_ENV === 'production',
        },
    },
});

export default reactQueryClient;
